module.exports = __webpack_public_path__ + "static/media/VideoReel.6e07cf67.svg";